
export const initialState = {
    activeTab: '',
    loadMyCase: false,
    selectedTabActions: [],
    action: null,
    breadCrumbList: [],
    caseDetails: null,
    caseStateLu: [],
    updatedDocuments: [],
    assignedTo: [],
    templateLU: [],
    btnLoader: false,
    loader: false,
    error: null,
    caseData: {},
    documents: [],
    docRepository: [],
    replyLoader: null,
    loading: true,
    docunetDetailId: null,
    isDeleteRecord: false,
    isDeleted: false,
    caseStateSelect:'',
    assignedToNames:''
  };
  
  export const casesReducer = (state, action) => {
    switch (action.type) {
      case 'SET_IS_DELETED_RECORD':
        return { ...state, isDeleteRecord: action.payload };
      case 'SET_IS_DELETED':
        return { ...state, isDeleted: action.payload };
      case 'SET_ACTIVE_TAB':
        return { ...state, activeTab: action.payload };
      case 'SET_LOAD_MY_CASE':
        return { ...state, loadMyCase: action.payload };
      case 'SET_SELECTED_TAB_ACTIONS':
        return { ...state, selectedTabActions: action.payload };
      case 'SET_ACTION':
        return { ...state, action: action.payload };
      case 'SET_CASE_STATE_LU':
        return { ...state, caseStateLu: action.payload };
      case 'UPDATE_DOCUMENTS':
        return { ...state, updatedDocuments: action.payload };
      case 'SET_REPLY_LOADER':
        return { ...state, replyLoader: action.payload };
      case 'SET_DOC_REPOSITORY':
        return { ...state, docRepository: action.payload, replyLoader: null };
      case 'SET_DOCUNET_DETAIL_ID':
        return { ...state, docunetDetailId: action.payload };
      case 'SET_LOADER':
        return { ...state, loader: action.payload };
      case 'SET_BTN_LOADER':
        return { ...state, btnLoader: action.payload };
      case 'SET_SHOW_PREVIEW_MODEL':
        return { ...state, showPreviewModal: action.payload };
      case 'SET_ERROR':
        return { ...state, error: action.payload };
      case 'SET_CASE_DETAILS':
        return { ...state, caseDetails: action.payload };
      case 'SET_ADMINS_DATA':
        return { ...state, adminsData: action.payload };
      case 'SET_CASE_STATE':
        return { ...state, caseStateSelect: action.payload };
      case 'SET_TEMPLATE_LU':
        return { ...state, templateLU: action.payload };
        case 'SET_ASSIGNED_NAMES':
        return { ...state, assignedToNames: action.payload };
      case 'SET_BREADCRUMB':
        return { ...state, breadCrumbList: action.payload };
      case 'SET_CASE_DATA':
        return {
          ...state,
          caseData: action.payload.caseData,
          documents: action.payload.documents,
          loading: false,
        };
      default:
        return state;
    }
  };
  